import React from 'react';
import Table from '~components/molecules/Table';

import * as Styles from './_apiKeyHistoryTable.module.scss';
import { useAppSelector } from '~redux/hooks';
import UtilFunctions from '~utils/functions';

const APIKeyHistoryTable = () => {
    const {
        Misc: {
            dateTimeFormat,
        },
    } = UtilFunctions;

    const apiKeyHistoryListing = useAppSelector(state => state.setting.apiKeyHistoryListing.data);
    const apiKeyHistoryListingIsLoading = useAppSelector(state => state.setting.loadings.getApiKeyHistoryListing);

    const tableHeader = [
        'DATE',
        'ITEM',
        'CREATED BY',
    ];

    const tableData = apiKeyHistoryListing.map(data => {
        const {
            createdBy,
            isManualRenewal,
            updatedAt,
        } = data;

        return [
            dateTimeFormat(updatedAt),
            isManualRenewal ? 'MANUAL API KEY RENEWAL' : 'AUTOMATED API KEY RENEWAL',
            createdBy || '-',
        ];
    });

    return (
        <Table
            header={tableHeader}
            body={tableData}
            isLoading={apiKeyHistoryListingIsLoading}
        />
    );
};

export default APIKeyHistoryTable;
